import { PropsWithChildren } from "react";

import { DefaultButton, IButtonProps, useFormContext } from "@bps/fluent-ui";
import { DangerButton } from "@components/buttons/DangerButton";
import { ComparisonOperator } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { SelectorFormValues } from "../selectors/edit/formUtils";

interface CreateSelectorFromCriteriaButtonProps
  extends PropsWithChildren,
    IButtonProps {
  onCreate: (isCreateAllowed: boolean) => void;
}

export const CreateSelectorFromCriteriaButton: React.FC<CreateSelectorFromCriteriaButtonProps> = ({
  onCreate,
  children,
  ...props
}) => {
  const { state } = useFormContext<SelectorFormValues>();

  const anyRuleContainsLike =
    state.values.rules?.some(
      x => x.comparisonOperator === ComparisonOperator.Like
    ) ?? false;

  const buttonProps = {
    isCreateAllowed: !anyRuleContainsLike,
    onClick: () => {
      onCreate(!anyRuleContainsLike);
    },
    ...props
  };

  return (
    <CreateSelectorFromCriteriaButtonWrapper {...buttonProps}>
      Create Selector from Criteria
    </CreateSelectorFromCriteriaButtonWrapper>
  );
};

const CreateSelectorFromCriteriaButtonWrapper: React.FC<PropsWithChildren &
  IButtonProps & {
    isCreateAllowed: boolean;
  }> = ({ isCreateAllowed, children, ...props }) => {
  return isCreateAllowed ? (
    <DefaultButton {...props}>{children}</DefaultButton>
  ) : (
    <DangerButton {...props}>{children}</DangerButton>
  );
};
